import client from '@/api/client'
import { IRecommendedAppsConfig, ILaunchPadConfig } from '@/pages/appstore/entities/appstore'

export async function saveAppstoreItem(data) {
    return await client.post(`/appstore/save`, data)
}

export async function uploadImage(data) {
    return await client.post(`/appstore/upload-image`, data)
}

export async function reorderLinkedLearnings(data) {
    return await client.post(`/appstore/reorder-linked-learnings`, data)
}

export async function fetchLearning(baseURL: string, id: string) {
    const response = await client.get(`learning/view/${id}`, {
        baseURL
    })

    return response.data
}

export async function saveLaunchPadConfig(config: ILaunchPadConfig) {
    const response = await client.post(`user/config`, config)

    return response.data
}

export async function saveRecommendedAppsConfig(config: IRecommendedAppsConfig) {
    const response = await client.post(`user/config`, config)

    return response.data
}

export async function getHelpRequest(params) {
    const response = await client.post(
        `/appstore/get-help-request`,
        params
    )

    return response.data
}

export async function requestCustomerSupport(params) {
    const response = await client.post(
        `/appstore/request-customer-support`,
        params
    )

    return response.data
}

export async function installApp(appName: string) {
    const formData = new FormData()
    formData.append('name', appName)
    return await client.post(`/appstore/install`, formData)
}

// export async function getSuggestion(id: number) {
//     return await client.get<SuggestionRelations>(`/ajax/suggestion/${id}`, { baseURL: '/' })
// }
